import {observable, action, runInAction} from "mobx";
import {RootStore} from "./stores";
import {request} from "../utils";
import {
    locationRestSettingsGet,
    ParamsRouteSettingsGet,
    RequestRouteSettingsGet,
    ResponseRouteSettingsGet
} from "../wp-api";
import {
    locationRestSettingsSet,
    ParamsRouteSettingsSet,
    RequestRouteSettingsSet,
    ResponseRouteSettingsSet
} from "../wp-api/settings.post";

/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */
class SettingsStore {

    @observable
    public settings: any;

    public readonly rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action
    public async get() {
        const data = await request<RequestRouteSettingsGet, ParamsRouteSettingsGet, ResponseRouteSettingsGet>({
            location: locationRestSettingsGet
        })

        runInAction(() => {
            this.settings = data;
        });

    }

    @action
    public async save() {
        console.log('this.settings: ', this.settings);
        const response = await request<RequestRouteSettingsSet, ParamsRouteSettingsSet, ResponseRouteSettingsSet>({
            location: locationRestSettingsSet,
            params: this.settings
        });

        runInAction(() => {
            this.settings = response;
        });
    }

    @action
    public setModifyDomain(allowed: boolean) {
        runInAction(() => {
            this.settings = this.settings || {};
            this.settings.modify_domain = allowed;
        });
    }

    @action
    public setInitialDomain(name: string) {
        runInAction(() => {
            this.settings = this.settings || {};
            this.settings.initial_domain = name;
        });
    }

    @action
    public setTargetDomain(name: string) {
        runInAction(() => {
            this.settings = this.settings || {};
            this.settings.target_domain = name;
        });
    }
}

export {SettingsStore};
